import { all, put, takeLatest } from 'redux-saga/effects';
import { NotFoundError } from '@factorin/rest';

import { apiCall } from 'Modules/core/api';
import * as Render from 'Modules/business/editor-render/render';
import { ActionPayload } from 'Modules/core/redux';
import { storageActions } from 'Modules/business/data';

import { NEWS_DOMAIN_PATH, news } from '../../api';
import { newsActions } from './actions';
import { errorKeys, errorTypes } from './errors';
import { GetItemType } from './types';


function* setBusy(value) {
    yield put(newsActions.setStatus({ busy: value }));
}

function* setError(type, key) {
    yield put(newsActions.setError({ type, key }));
}

function* getNewsItem({ $payload: { id, screenType } }: ActionPayload<GetItemType>) {
    yield setBusy(true);
    yield setError(errorTypes.newsItem, null);
    try {
        const [itemData, neighbours] = yield all([
            apiCall(news.item, { id }),
            apiCall(news.neighbours, { query: { id } }),
        ]);
        yield put(storageActions.receive(
            NEWS_DOMAIN_PATH,
            {
                [id]: {
                    ...itemData,
                    RenderContent: Render.renderContent(itemData.Content, screenType),
                    Neighbours: neighbours,
                },
            },
        ));
    } catch (error) {
        yield setError(
            errorTypes.newsItem,
            error instanceof NotFoundError
                ? errorKeys.itemNotFoundError
                : errorKeys.unknownError,
        );
    }

    yield setBusy(false);
}

export const sagas = [
    takeLatest(`${newsActions.getItem}`, getNewsItem),
];
